const RESOURCES_NEWNESS_VERSION = '2026-07-provider-directories';
const RESOURCES_SEEN_EVENT = 'scribeshadow:resources-seen-changed';

const resourcesSeenKey = `scribeshadow.resources.seen.${RESOURCES_NEWNESS_VERSION}`;
const categorySeenKey = (categoryId: string) =>
  `scribeshadow.resources.categorySeen.${RESOURCES_NEWNESS_VERSION}.${categoryId}`;

const canUseLocalStorage = () =>
  typeof window !== 'undefined' && Boolean(window.localStorage);

const readSeenFlag = (key: string): boolean => {
  try {
    return canUseLocalStorage() && window.localStorage.getItem(key) === '1';
  } catch {
    return false;
  }
};

const writeSeenFlag = (key: string): void => {
  try {
    if (canUseLocalStorage()) {
      window.localStorage.setItem(key, '1');
    }
  } catch {
    // Ignore storage failures in private browsing or restricted test environments.
  }
};

export const hasSeenResources = (): boolean => readSeenFlag(resourcesSeenKey);

export const markResourcesSeen = (): void => {
  writeSeenFlag(resourcesSeenKey);
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(RESOURCES_SEEN_EVENT));
  }
};

export const onResourcesSeenChange = (listener: () => void): (() => void) => {
  if (typeof window === 'undefined') {
    return () => {};
  }
  window.addEventListener(RESOURCES_SEEN_EVENT, listener);
  window.addEventListener('storage', listener);
  return () => {
    window.removeEventListener(RESOURCES_SEEN_EVENT, listener);
    window.removeEventListener('storage', listener);
  };
};

export const hasSeenResourceCategory = (categoryId: string): boolean =>
  readSeenFlag(categorySeenKey(categoryId));

export const markResourceCategoriesSeen = (categoryIds: string[]): void => {
  categoryIds.forEach((categoryId) => writeSeenFlag(categorySeenKey(categoryId)));
};

export const markResourceCategorySeen = (categoryId: string): void => {
  writeSeenFlag(categorySeenKey(categoryId));
};
